import api from '@/api';
import { API_BASE_URL } from '..';
import {
  GenerateLgpdTermInterface,
  generateTermsWorkorderInterface,
} from './GenerateTerm.types';

const baseUrl = API_BASE_URL;

export async function generateLgpdTerm(obj: GenerateLgpdTermInterface) {
  const result = (await api.getReport(
    `${baseUrl}/generate/terms/lgpd`,
    obj,
  )) as unknown;

  return result as BlobPart;
}

export async function generateTermsWorkorder({
  term,
  ...obj
}: generateTermsWorkorderInterface) {
  const result = (await api.getReport(
    `${baseUrl}/generate/terms/${term}`,
    obj,
  )) as unknown;

  return result as BlobPart;
}
